<template>
    <div class="base-course-container">
        <!-- HEADER -->
        <div class="header">
            <div class="header-right">
                <img class="offset" :src="Offset" alt="Offset">
                <img @click="back" class="back" :src="Back" alt="Back">
                <img class="cropped-head" :src="CroppedHead" alt="CroppedHead">

                <canvas id="myChart" width="100" height="100"></canvas>
                <p id="myChartText" v-if="seen + notSeen"> 
                    <span>{{ ((seen * 100) / (seen + notSeen)).toFixed(0) }}%</span>
                    <span style="font-size: 4vh; margin-top: calc(4vh + 10px); display: inline-block;">طی شده</span>
                </p>

                <div class="description">
                    <h1>{{ response.Title }} </h1>
                    <div class="desc-line">
                        <img class="icon-img" :src="Video" alt="Video">
                        <span>تعداد ویدیوها: </span>
                        <span class="answer">{{ response.VideosCount }}</span>
                    </div>
                    <div class="desc-line">
                        <img class="icon-img" :src="Time" alt="Time">
                        <span>مدت زمان تقریبی این دوره: </span>
                        <span class="answer">{{ response.Duration }} دقیقه</span>
                    </div>
                </div>
            </div>
            <div class="header-left">
                <div class="inner"></div>
            </div>
        </div>

        <!-- NOTIFICATION -->
        <div id="notifBoX" class="notification" v-if="showNotif">
            <!-- <span class="title">راهنما</span>  -->
            <div class="inner">
                <img class="inner-img" :src="SmartPerson" alt="SmartPerson">
                <div class="inner-desc">
                    <span>لـطـفـا قبل از شروع، راهنمای دوره را مطالعه کن</span>

                    <button @click="show" class="btn btn-success">بزن بریم</button>
                    <button @click="notImpo" class="btn btn-outline-warning">فعلا بیخیال</button>
                </div>
            </div>
        </div>

        <!-- SESSIONS -->
        <div class="sessions">
            <span class="title">ویدیوها</span>

            <div 
                class="session"
                v-for="(session, index) in sessions" :key="index" 
                :class="{ start: index == 0, end: index == sessions.length - 1 }"
            >
                <div class="vertical-bar"></div>
                <div class="inner" @click="disClick(index)">
                    <div class="desc">
                        <div class="circle">
                            <img v-if="session.notSeen" :src="Lock" alt="Lock">
                            <i  v-else class="fas fa-check-circle"></i>
                        </div>
                        
                        <span class="desc-title">{{ session.Title }}</span>

                        <span v-if="session.notSeen" class="desc-text not-seen">مشاهده نشده</span>
                        <span v-else class="desc-text">مشاهده شده</span>
                    </div>

                    <template v-if="index">
                        <router-link 
                            tag="button"
                            :disabled="sessions[index - 1].notSeen"
                            class="btn desc-btn"
                            :class="sessions[index - 1].notSeen ? 'btn-dark' : 'btn-light'"
                            :to="{ name: 'BaseCourseDetails', params: { id: session.Id } }"
                        >{{ sessions[index].notSeen ? 'مشاهده' : 'کامل شد' }}</router-link>
                    </template>
                    <template v-else>
                        <router-link 
                            tag="button"
                            class="btn btn-light desc-btn"
                            :to="{ name: 'BaseCourseDetails', params: { id: session.Id } }"
                        >{{ sessions[0].notSeen ? 'مشاهده' : 'کامل شد' }}</router-link>
                    </template>

                    <div class="progress" style="width: 100%; margin: auto 10px 0; direction: ltr">
                        <div 
                            v-if="!session.notSeen"
                            class="progress-bar bg-success" 
                            role="progressbar" style="width: 100%" 
                            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                        </div>
                        <div 
                            v-else
                            class="progress-bar" :class="getColor(session.Id)"
                            role="progressbar" :style="{width: getTime(session.Id)}" 
                            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Time from '@/assets/images/courses/content/time-icon.png';
import Video from '@/assets/images/courses/content/video-icon.png';

import Back from '@/assets/images/courses/content/back.png';
import Offset from '@/assets/images/courses/content/offset.png';
import SmartPerson from '@/assets/images/courses/content/smart_person.png';

import Lock from '@/assets/images/courses/content/lock.png';
import Clock from '@/assets/images/courses/content/clock.png';

import CroppedHead from '@/assets/images/CroppedHead.png';

import { getRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';
let Chart = require('chart.js');

export default {
    name: 'BaseCourse',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Time: Time,
            Video: Video,

            Back: Back,
            Offset: Offset,
            Lock: Lock,
            Clock: Clock,
            SmartPerson: SmartPerson,
            CroppedHead: CroppedHead,

            firstname: undefined,
            prevRoute: {},
            showNotif: true,

            courseId: this.$route.params.course,
            response: {},
            sessions: [],

            seen: 0,
            notSeen: 0
        }
    },
    mounted() {
        this.needNotif();
        this.getCurrent();
    },
    methods: {
        getTime(id) {
            let t = Cookies.get(id) || 0;

            t = (t * 100).toFixed();
            return t < 1 ? '1%' : (t + '%');
        },

        getColor(id) {
            let t = Cookies.get(id) || 0;
            t = (t * 100).toFixed();

            if(t < 30) return 'bg-danger'
            else if(t < 70) return 'bg-orange'
            else return 'bg-warning'
        },

        disClick(index) {
            if(index > 0) {
                if(this.sessions[index - 1].notSeen) {
                    this.$modal.show('dialog', {
                        title: 'هشدار!',
                        text: (this.firstname || 'کاربر ') + ' عزیز، جهت بهبود عملکرد دوره تا بخش قبلی را نبینید بعدی باز نمی‌شود.',
                        buttons: [
                            {
                                title: 'بستن',
                                default: true,
                            }
                        ]
                    });
                }
            }
        },

        createChart() {
            let ctx = document.getElementById('myChart');
            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [this.notSeen, this.seen],
                        backgroundColor: [
                            '#24327c',
                            '#00f6ff',
                        ],
                        borderColor: [
                            '#24327c',
                            '#00f6ff',
                        ],
                        borderWidth: '1px',
                        fill: false,
                    }]
                },
                options: {
                    responsive: true,
                    cutoutPercentage: 95
                }
            });
        },
        getCurrent() {
            getRequest('/base-courses/find-one', { id: this.courseId })
                .then((rsp) => {
                    let data = rsp['data'].course
                    let userId = rsp['data'].userId

                    getRequest('/users/user')
                        .then(rsp => {
                            // response
                            let userCourses = rsp['data'].UserCourses;
                            if(userCourses.indexOf(data._id) == -1) {
                                this.$router.push({ name: 'Khanesh' })
                            }

                            this.firstname = rsp['data'].FirstName;

                            this.response = data;
                            this.seen = 0;
                            this.notSeen = 0;
                            data['Videos'].forEach(v => {
                                if (v.SeenBy.indexOf(userId) > -1) this.seen++;
                                else this.notSeen++;

                                this.sessions.push({
                                    Title: v.Title,
                                    Id: v._id,
                                    notSeen: (v.SeenBy.indexOf(userId) > -1) ? false : true
                                })
                            });

                            this.createChart()
                        })
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        needNotif() {
            let auth = Cookies.get('access_cookie');
            let data = Cookies.get(this.courseId);

            if (auth && data) {
                let list = JSON.parse(data)
                this.showNotif = !(list.indexOf(auth) > -1);
            } else {
                this.showNotif = true;
            }
        },
        show() {
            let auth = Cookies.get('access_cookie');
            let data = Cookies.get(this.courseId);

            this.$modal.show('dialog', {
                title: 'هشدار!',
                text: this.response.Desc || 'راهنمایی موجود نمی‌باشد',
                buttons: [
                    {
                        title: 'مطالعه گردید',
                        handler: () => { 
                            document.getElementById('notifBoX').style.opacity = 0;

                            setTimeout(() => {
                                if (auth && data) {
                                    let list = JSON.parse(data)
                                    list.push(auth);

                                    Cookies.set(this.courseId, JSON.stringify(list))
                                } else if (auth) {
                                    Cookies.set(this.courseId, [auth])
                                }

                                this.showNotif = false;
                            }, 500);
                            

                            this.$modal.hide('dialog');
                        }
                    }
                ]
            });
        },
        notImpo() {
            document.getElementById('notifBoX').style.opacity = 0;
            setTimeout(() => {
                this.showNotif = false;
            }, 500);
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
.base-course-container {
    background-color: #ebecf1;
}
.base-course-container .bg-orange {
    background-color: #ec8e00;
}
.base-course-container #myChart {
    height: 35vh !important;
    width: 35vh !important;
    margin: 10vh auto 10vh 25pt;

}
.base-course-container #myChartText {
    color: #fff;
    font-size: 10vh;
    margin: calc(-32.5vh - .5rem) 0 0 12.5vh;
    text-align: left;

    display: flex;
    flex-direction: column;

    font-family: 'IRANSans', Arial, sans-serif;
}
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.base-course-container .header {
    height: 55vh;

    display: flex;
    flex-direction: row;

    background-color: #191e5e;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    overflow: hidden;
    position: relative;
}
.base-course-container .header-right {
    height: 55vh;
    width: calc(100vw - 25pt);

    position: relative;
}
.base-course-container .header-right .cropped-head {
    max-width: 50vw;

    position: absolute;
    bottom: 0;
    right: 0;
}
.base-course-container .header-right .offset {
    position: absolute;
    bottom: 0;
    left: 0;

    height: 25pt;
    width: 25pt;
}
.base-course-container .header-right .back {
    height: 5vh;

    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.base-course-container .header-left {
    height: 55vh;
    width: 25pt;
}
.base-course-container .header-left .inner {
    height: 55vh;
    width: 25pt;
    background-color: #ebecf1;

    border-top-right-radius: 25pt;
}
@media (max-width: 576px) {
    .base-course-container .header-right {
        width: calc(100vw - 15pt);
    }
    .base-course-container .header-left {
        width: 15pt;
    }
    .base-course-container .header-left .inner {
        width: 15pt;
        border-top-right-radius: 15pt;
    }
}

/* ---------------------------------------- */
/* -------------- HEADER DESC ------------- */
/* ---------------------------------------- */
.base-course-container .header-right .description {
    width: 245pt;
    
    position: absolute;
    top: 15vh;
    right: 15pt;

    color: #fff;
}
.base-course-container .header-right .desc-line {
    color: #aaadc5;
    margin-top: 5pt;
}
.base-course-container .header-right .answer {
    color: #fecd02;
    font-weight: bold;
}
.base-course-container .header-right .desc-line .icon-img {
    width: 1rem;
    margin-left: 5pt;
}
@media (max-width: 764px) {
    .base-course-container #myChart {
        height: 25vh !important;
        width: 25vh !important;
        margin: 10pt auto 10vh 15pt;
    }
    .base-course-container #myChartText {
        width: 25vh;
        margin: -23.5vh auto auto 15pt;

        font-size: 7vh;
        text-align: center;
        line-height: 0;
    }
    .base-course-container .header-right .description h1 {
        font-size: 1.75rem;
    }
    .base-course-container .header-right .description .desc-line {
        font-size: 0.75rem;
    }
    .base-course-container .header-right .description {
        width: calc(100% - 10pt);
        top: 29.5vh;
        right: 10pt;
    }
}

/* ---------------------------------------- */
/* ------------- NOTIFICATION ------------- */
/* ---------------------------------------- */
.base-course-container .notification {
    padding: 50pt 25pt 15pt;
    position: relative;

    transition: opacity .5s;
}
/* .base-course-container .notification:after {
    height: 10pt;
    width: calc(100vw - 50pt);

    content: "";
    
    position: absolute;
    bottom: 0pt;
    left: 25pt;
    
    border: 1px solid #c5c5c5dd;
    border-radius: 5px;
    box-shadow: inset 3px 5px 4px #c5c5c5;
} */
.base-course-container .notification .title {
    height: 40pt;
    font-size: 18pt;
    display: inline-block;
}
.base-course-container .notification .inner {
    height: 20vh;
    width: 100%;

    position: relative;

    display: flex;
    flex-wrap: wrap;

    border-radius: 15pt;
    background-color: #fecd02;
    box-shadow: 7px 12px 16px #fecd0244;
}
.base-course-container .notification .inner .inner-desc {
    width: 100%;
    margin: auto;
    padding-top: 10pt;
    padding-right: 10pt;

    position: relative;
}
.base-course-container .notification .inner .inner-desc span {
    width: calc(100% - 16vh - 30pt);
    display: block;
    font-size: 80%;
}
.base-course-container .notification .inner .inner-desc button {
    min-width: 50pt;
    margin: 5pt 0 auto 5pt;

    color: #fff;
    border-radius: 15pt;
    border-width: 2pt;
}
.base-course-container .notification .inner .inner-desc button:last-child {
    margin: 5pt 5pt auto 0;   
}
.base-course-container .notification .inner .inner-img {
    height: calc(20vh + 20pt);

    position: absolute;
    bottom: 20pt;
    left: 0;
}
@media (max-width: 576px) {
    .base-course-container .notification {
        padding: 10pt 5pt 30pt;
    }
    .base-course-container .notification:after {
        left: 5pt;
        width: calc(100vw - 10pt);
    }
    .base-course-container .notification .inner {
        box-shadow: 3px 5px 5px #fecd0244;
    }
}

/* ---------------------------------------- */
/* --------------- SESSIONS --------------- */
/* ---------------------------------------- */
.base-course-container .sessions {
    padding: 20pt 0 0;
    position: relative;
}
.base-course-container .sessions .title {
    margin: 0 10pt 0 0;
    font-size: 18pt;
    display: inline-block;
}
.base-course-container .sessions .session {
    height: 25vh;
    width: 100%;

    position: relative;
}
.base-course-container .sessions .session .inner {
    height: 20vh;
    width: calc(100% - 20pt);

    position: absolute;
    top: 2.5vh;
    left: 10pt;

    display: flex;
    flex-wrap: wrap;

    border-radius: 10pt;
    background-color: #fff;
    /* background-color: #fecd02; */

    box-shadow: 2px 3px 5px #24327c44;
}
.base-course-container .sessions .session .inner .desc {
    margin: auto 10pt auto auto;
}
.base-course-container .sessions .session .inner .desc .desc-title {
    font-size: 1.1rem;
    color: #555;
    font-weight: bold;
    display: block;
}
.base-course-container .sessions .session .inner .desc .desc-text {
    font-size: .9rem;
    color: #2ad85f;
}
.base-course-container .sessions .session .inner .desc-btn {
    height: auto;
    min-width: 50pt;
    margin: auto auto auto 10pt;

    font-weight: bold;
    border-radius: 15pt;

    position: absolute;
    top: 25px;
    left: 0;

    box-shadow: 1pt 2px 5px #ccc;
}
.base-course-container .sessions .session .vertical-bar {
    height: 25vh;
    width: 15pt;

    position: absolute;
    bottom: 0;
    right: 10%;

    background-color: #fff;
}
.base-course-container .sessions .session .inner .circle {
    height: 7vh;
    width: 7vh;
    border-radius: 7vh;

    margin: auto calc(10vw - 3.5vh - 2.5pt) auto 0;

    display: flex;

    background-color: #f1f2f6;
    box-shadow: inset 3px 5px 3px #cccc;
}
.base-course-container .sessions .session .inner .circle i {
    margin: auto;
    font-size: 1.2rem;
    color: #2ad85f;
}
.base-course-container .sessions .session .inner .not-seen {
    color: #999 !important;
}
.base-course-container .sessions .session .inner .circle img {
    height: 50%;
    margin: auto;
}
/* start & end */
.base-course-container .sessions .session.start .vertical-bar {
    height: 20vh;
}
.base-course-container .sessions .session.end .vertical-bar {
    height: 20vh;
    bottom: 5vh;
}
.base-course-container .sessions .session .inner .inner-text {
    width: 50%;
    max-width: 250pt;
    margin: auto;
    margin-left: 15pt;
}
@media (max-width: 576px) {
    .base-course-container .sessions {
        padding: 10pt 0 0;
    }
    .base-course-container .sessions .session .inner {
        width: calc(100% - 10pt);
        padding: 10px 0;
        left: 5pt;
    }
    .base-course-container .sessions .session .inner .circle {
        /* margin-right: calc(10vw - 3.5vh + 2.5pt); */
        margin-right: 0;
        margin-bottom: 5pt;
    }
    /* desc */
    .base-course-container .sessions .session .inner .desc {
        /* margin: auto 5pt auto auto; */
        margin: auto 10pt;
    }
    .base-course-container .sessions .session .inner .desc-btn {
        font-size: .8rem;
    }
    .base-course-container .sessions .session .inner .desc .desc-title,
    .base-course-container .sessions .session .inner .desc .desc-text {
        font-size: .6rem;
    }
    .base-course-container .sessions .session .inner .inner-text {
        font-size: .7rem;
        margin-left: 5pt;
    }
}
</style>